/**
 * Jacob - 19/02/2020
 * Common module for all async calls
 */

import { IAppProps, REDUCER_KEY } from '../interface/IAppProvider';
import { IEmailPayloadBuy, IEmailPayloadQuote, EMAIL_EVENT, IGeneralCallMeEmailTemplate } from '../interface/IPayload';
import { getDefaultOptions, HTTP_METHOD } from './GetAsyncOptions';
import { TDispatch } from '../context/AppContext';

function handleHTTPErrors(response: Response, props: IAppProps, dispatch: TDispatch, options?: RequestInit) {
    if (response.ok) {
        dispatch({ type: REDUCER_KEY.LOADING_DATA, payload: false });
        return response.json();
    } else {
        response.json().then((jsonResponse) => {
            if (jsonResponse.errorCode === 20 && jsonResponse.message) {
                props.c9log.error(`handleHTTPErrors: Error Payload from server -', ${JSON.stringify(jsonResponse)}`);
                dispatch({ type: REDUCER_KEY.SET_EMAIL_EVENT, payload: EMAIL_EVENT.GENERAL_ERROR });
                dispatch({ type: REDUCER_KEY.SET_STATE_CHANGE, payload: true });
            } else if (jsonResponse.errorCode === 10 && jsonResponse.message) {
                props.c9log.error(`handleHTTPErrors: Error Payload from server -', ${JSON.stringify(jsonResponse)}`);
                dispatch({ type: REDUCER_KEY.SET_STATE_CHANGE, payload: true });
            } else {
                const responseData = `${response.status} ${response.statusText} ${response.type} ${JSON.stringify(
                    options,
                )}`;
                props.c9log.error(`handleHTTPErrors: Called ${response.url} Response: ${responseData}`, 'AsyncCalls');
            }
            routeToErrorPage(props, dispatch);
        });
    }
}

function handleGeneralErrors(serviceEnPoint: string, error: any, props: IAppProps, dispatch: TDispatch) {
    props.c9log.error(`handleGeneralErrors: Called ${serviceEnPoint} - error: ${error}`, 'AsyncCalls');
    routeToErrorPage(props, dispatch);
}

// Goto error url
export function routeToErrorPage(props: IAppProps, dispatch: TDispatch) {
    dispatch({ type: REDUCER_KEY.LOADING_DATA, payload: false });
    dispatch({ type: REDUCER_KEY.SET_ERROR, payload: { stepOne: false, stepTwo: false, separateCallMe: false } });
}

// General email service call
export const sendEmail = (
    context: IAppProps,
    dispatch: TDispatch,
    payload: IGeneralCallMeEmailTemplate | IEmailPayloadBuy | IEmailPayloadQuote,
) => {
    const options = getDefaultOptions(HTTP_METHOD.POST, context, 'wso2', payload);
    return fetch(`${context.config.wso2OpenApiUrl}/email`, options).then(
        (response) => handleHTTPErrors(response, context, dispatch, options),
        (err) => {
            handleGeneralErrors(`${context.config.wso2OpenApiUrl}/email`, err, context, dispatch);
        },
    );
};

// Persist data to cache and return key string
export const sendDataToObjectCache = async (
    props: IAppProps,
    dispatch: TDispatch,
    data: any,
): Promise<{ objectId: string }> => {
    dispatch({ type: REDUCER_KEY.LOADING_DATA, payload: true });
    const options = getDefaultOptions(HTTP_METHOD.POST, props, 'objectCache', data);
    return fetch(`${props.config.objectCacheUrl}`, options).then(
        (response) => handleHTTPErrors(response, props, dispatch, options),
        (err) => {
            handleGeneralErrors(props.config.objectCacheUrl, err, props, dispatch);
        },
    );
};

// Get data from object cache
export const getDataToObjectCache = async (props: IAppProps, dispatch: TDispatch, cacheId: string) => {
    const options = getDefaultOptions(HTTP_METHOD.GET, props, 'objectCache');
    return fetch(`${props.config.objectCacheUrl}/${cacheId}`, options).then(
        (response) => handleHTTPErrors(response, props, dispatch, options),
        (err) => {
            handleGeneralErrors(`${props.config.objectCacheUrl}/${cacheId}`, err, props, dispatch);
        },
    );
};

/**
 * Get CVR data
 * @param props
 * @param dispatch
 */
export const getCvrData = (props: IAppProps, dispatch: TDispatch, cvrNumber: string) => {
    dispatch({ type: REDUCER_KEY.LOADING_DATA, payload: true });
    const url = `${props.config.apiAwsHost}/cvr/v1/${cvrNumber}`;
    const options = getDefaultOptions(HTTP_METHOD.GET, props, 'cvr');
    return fetch(url, options);
};
